module.exports = __webpack_public_path__ + "media/images/emblems/Oberweningen-blazon-ead47be56dc9a0baea960dd921fdadec.svg";